import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "ignore-period-renderer" }, [
    _c("span", { staticClass: "ignore-period-renderer__text" }, [
      _vm._v(_vm._s(_vm.params.value || "")),
    ]),
    _vm._v(" "),
    _vm.isEditable
      ? _c(
          "span",
          {
            staticClass: "ignore-period-renderer__icon",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
              click: function ($event) {
                $event.stopPropagation()
                return _vm.openPicker.apply(null, arguments)
              },
            },
          },
          [
            _c(VIcon, { attrs: { "x-small": "" } }, [
              _vm._v("mdi-calendar-range"),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }